import { DateTime } from 'luxon';

import { accountsSelectors } from 'app-components/flux/accounts';
import { categoriesSelectors } from 'app-components/flux/categories';
import * as transactionsTypes from 'app-components/flux/transactions/transactionsTypes';
import store from 'app-components/utils/redux-store';

const allTaxLineItemsTransactions = () => {
  let resources;
  if (store) {
    const categories = categoriesSelectors.getResourcesById(store.getState());
    const taxLineItemsCategories = categories.filter((category) => category.txfId);
    const account = accountsSelectors.getBankAccounts(store.getState()).first();
    const incomeAmount = 10000;
    const expenseAmount = -100;
    resources = taxLineItemsCategories.toIndexedSeq().reduce(
      (transactions, taxLineItemCategory, index) => [
        ...transactions,
        transactionsTypes.mkCashFlowTransaction({
          accountId: account?.id,
          coa: { type: 'CATEGORY', id: taxLineItemCategory.id || '' },
          postedOn: DateTime.now().toISODate(),
          payee: `${taxLineItemCategory.txfId} - Payee`,
          amount: taxLineItemCategory?.type === 'INCOME' ? incomeAmount + index : expenseAmount - index,
          state: 'CLEARED',
          businessId: taxLineItemCategory?.usageType === 'BUSINESS' ? account?.businessId : undefined,
        }),
      ],
      [],
    );
  }
  return { resources };
};
``;
export default allTaxLineItemsTransactions;
